/* The hero piece (prototype: .vStudio .hero.heroFull.onPhoto). Colors are theme tokens only. */
@layer telify {
  /* No About photo: the same hero on the page ground, never an empty block. */
  .hero {
    position: relative;
    text-align: center;
    /* Layout 1 Tighter (Gabriel 2026-10-20): a fixed 620px, from the old clamp up to 900px. */
    height: 620px;
    overflow: hidden;
    background: var(--bg-page);
    color: var(--text-primary);
  }

  .withPhoto {
    --scrim-rgb: var(--bg-page-rgb);
    background: var(--bg-card);
  }

  /* A light look shades the photo dark and sets its words light, as the prototype's .onPhoto does. */
  :global(html[data-look='light']) .withPhoto {
    --scrim-rgb: var(--fg-page-rgb);
    --text-primary: rgb(var(--bg-page-rgb));
    --text-secondary: rgba(var(--bg-page-rgb), 0.86);
    --text-tertiary: rgba(var(--bg-page-rgb), 0.7);
    --text-muted: rgba(var(--bg-page-rgb), 0.55);
    --accent: rgba(var(--bg-page-rgb), 0.8);
    --border-soft: rgba(var(--bg-page-rgb), 0.22);
    --field-line: rgba(var(--bg-page-rgb), 0.5);
  }

  :global(html[data-look='light']) .withPhoto .primary {
    background: rgb(var(--bg-page-rgb));
    color: rgb(var(--fg-page-rgb));
  }

  .photo {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: 50% 62%;
  }

  .scrim {
    position: absolute;
    inset: 0;
    background:
      radial-gradient(ellipse 46% 40% at 50% 44%, rgba(var(--scrim-rgb), 0.42) 0%, rgba(var(--scrim-rgb), 0) 100%),
      linear-gradient(
        180deg,
        rgba(var(--scrim-rgb), 0.6) 0%,
        rgba(var(--scrim-rgb), 0.48) 42%,
        rgba(var(--scrim-rgb), 0.7) 76%,
        rgba(var(--scrim-rgb), 0.9) 100%
      );
  }

  .inner {
    position: relative;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    /* Room for the facts row, so it never overlaps the buttons. */
    padding-bottom: 120px;
  }

  .eyebrow {
    justify-content: center;
  }

  .eyebrow::after {
    content: '';
    width: 28px;
    height: 1px;
    background: var(--accent);
  }

  .name {
    margin-top: 24px;
    font-family: var(--font-display);
    font-weight: 500;
    font-size: 96px;
    line-height: 0.96;
    letter-spacing: -0.03em;
    overflow-wrap: break-word;
    max-width: 100%;
  }

  .name em {
    font-style: italic;
    font-weight: 400;
    color: var(--accent);
    padding: 0 0.02em;
  }

  .lead {
    margin-top: 26px;
    font-size: 19px;
    line-height: 1.6;
    color: var(--text-secondary);
    max-width: 50ch;
  }

  .ctas {
    margin-top: 36px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 12px;
  }

  /* The facts row, at the hero's foot; as many columns as there are facts. */
  .facts {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    padding-bottom: 26px;
    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: 232px;
    justify-content: center;
    border-top: var(--line);
  }

  .fact {
    min-width: 0;
    padding: 18px 20px 4px;
    text-align: center;
    border-left: var(--line);
  }

  .fact:first-child {
    border-left: 0;
  }

  .factK {
    font-size: 12.5px;
    color: var(--text-tertiary);
  }

  .factV {
    margin-top: 4px;
    font-size: 16.5px;
    font-weight: 500;
  }

  .factV small {
    display: block;
    margin-top: 2px;
    font-size: 13.5px;
    font-weight: 400;
    color: var(--text-tertiary);
  }

  @media (hover: hover) {
    .factV a:hover {
      color: var(--accent);
    }
  }

  @media (max-width: 1023px) {
    .hero {
      height: auto;
      min-height: 560px;
    }

    .inner {
      padding: 72px 0 140px;
    }

    .name {
      font-size: 54px;
      line-height: 1;
    }

    /* Full width at phone; .hero raises it over the shared .wrap width. */
    .hero .facts {
      width: 100%;
      grid-auto-columns: minmax(0, 1fr);
    }
  }
}
